import InstitutionCard from "Benchmarking/Components/InstitutionCard";
import { PaginationAdjustComponentBenchmarking } from "Benchmarking/Components/PaginationComponent";
import SearchAdvanceInstitution from "Benchmarking/Components/SearchAdvanceInstitution";
import "Benchmarking/Scss/InstitutionProfiles.scss";
import {
  getInstitutionExplore,
  getSearchInstitution,
} from "Benchmarking/Services/Institution";
import { List, Spin } from "antd";
import { useEffect, useState } from "react";

const InstitutionProfiles = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [pagination, setPagination] = useState({
    page: 1,
    rowsPerPage: 16,
    totalRows: 0,
  });
  const [totalData, setTotalData] = useState([]);
  const [compareList, setCompareList] = useState([]);
  const [filters, setFilters] = useState({
    query: null,
    classifications: null,
    states: null,
  });
  useEffect(() => {
    if (totalData.length == 0) {
      getInstitutionExplore((res) => {
        setTotalData(res);
        setCompareList(
          res.slice(
            (pagination.page - 1) * pagination.rowsPerPage,
            pagination.page * pagination.rowsPerPage
          )
        );
        setPagination({
          ...pagination,
          totalRows: res.length,
        });
        setIsLoading(false);
      });
    }
    setCompareList(
      totalData.slice(
        (pagination.page - 1) * pagination.rowsPerPage,
        pagination.page * pagination.rowsPerPage
      )
    );
  }, [pagination.page, pagination.rowsPerPage]);

  useEffect(() => {
    if (
      filters.query !== null ||
      filters.classifications !== null ||
      filters.states !== null
    ) {
      setIsLoading(true);
      getSearchInstitution(filters, (res) => {
        setCompareList(res);
        setPagination({
          ...pagination,
          totalRows: res.length,
        });
        setIsLoading(false);
      });
    }
  }, [filters]);
  console.log(filters);
  return (
    <div className="institution-list scroll-section">
      <div className="left-side">
        <div className="search">
          <SearchAdvanceInstitution filters={filters} setFilters={setFilters} />
        </div>

        {isLoading ? (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Spin />
          </div>
        ) : (
          <div className="list">
            <List
              grid={{
                gutter: 25,
                column: 4,
              }}
              dataSource={compareList}
              renderItem={(item, index) => {
                return (
                  <List.Item key={index}>
                    <InstitutionCard
                      data={item}
                      compareList={compareList}
                      setCompareList={setCompareList}
                    />
                  </List.Item>
                );
              }}
            />
            <PaginationAdjustComponentBenchmarking
              pagination={pagination}
              setPagination={setPagination}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default InstitutionProfiles;
